import React, { Component } from 'react';
import './PopoverListDropdown.css';

class PopoverListDropdown extends Component {
  changeLabel = (event) => {
    console.log('Got change event:', event.target);
  }

  handleChange = (event) => {
    const { onChange } = this.props;
    onChange(event.target.value);
    // console.log("Got new value:", event, event.target);
  }

  render() {
    const { label, value, valueLabelPrefix } = this.props;

    return (
      <div className="PopoverListDropdown">
        <label className="PopoverListDropdown__label">{label}</label>

        <span className="PopoverListDropdown__value">{valueLabelPrefix}</span>
        <select className="PopoverListDropdown__select" value={value} onChange={this.handleChange}>
          {this.props.children}
        </select>

      </div>
    );
  }
}

export default PopoverListDropdown;



// WEBPACK FOOTER //
// ./src/components/PopoverListDropdown.js